var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCableChannelsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "40px",
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "75F4355F-914E-431A-AE15-458865D8815E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-130.000000, -1712.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(13.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cable-channels-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,2.5 C46.3828125,2.5 47.5,3.6171875 47.5,5 L47.5,30 C47.5,31.3828125 46.3828125,32.5 45,32.5 L5,32.5 C3.6171875,32.5 2.5,31.3828125 2.5,30 L2.5,5 C2.5,3.6171875 3.6171875,2.5 5,2.5 L45,2.5 Z M5,0 C2.2421875,0 0,2.2421875 0,5 L0,30 C0,32.7578125 2.2421875,35 5,35 L45,35 C47.7578125,35 50,32.7578125 50,30 L50,5 C50,2.2421875 47.7578125,0 45,0 L5,0 Z M7.5,38.75 C7.5,39.4375 8.0625,40 8.75,40 L41.25,40 C41.9375,40 42.5,39.4375 42.5,38.75 C42.5,38.0625 41.9375,37.5 41.25,37.5 L8.75,37.5 C8.0625,37.5 7.5,38.0625 7.5,38.75 Z M31.9609375,7.71875 C31.625,7.484375 31.1953125,7.4296875 30.8125,7.578125 L20.8125,11.328125 C20.328125,11.5078125 20,11.9765625 20,12.5 L20,19.5703125 C19.609375,19.4453125 19.1875,19.375 18.75,19.375 C16.6796875,19.375 15,20.9140625 15,22.8125 C15,24.7109375 16.6796875,26.25 18.75,26.25 C20.8203125,26.25 22.5,24.7109375 22.5,22.8125 C22.5,22.75 22.5,22.6875 22.4921875,22.6171875 C22.4921875,22.578125 22.5,22.5390625 22.5,22.5 L22.5,13.3671875 L30,10.5546875 L30,17.0703125 C29.609375,16.9453125 29.1875,16.875 28.75,16.875 C26.6796875,16.875 25,18.4140625 25,20.3125 C25,22.2109375 26.6796875,23.75 28.75,23.75 C30.8203125,23.75 32.5,22.2109375 32.5,20.3125 C32.5,20.25 32.5,20.1875 32.4921875,20.1171875 C32.4921875,20.078125 32.5,20.0390625 32.5,20 L32.5,8.75 C32.5,8.34375 32.296875,7.953125 31.9609375,7.71875 L31.9609375,7.71875 Z M30,20.3125 C30,20.6328125 29.6484375,21.25 28.75,21.25 C27.8515625,21.25 27.5,20.6328125 27.5,20.3125 C27.5,19.9921875 27.8515625,19.375 28.75,19.375 C29.6484375,19.375 30,19.9921875 30,20.3125 Z M20,22.8125 C20,23.1328125 19.6484375,23.75 18.75,23.75 C17.8515625,23.75 17.5,23.1328125 17.5,22.8125 C17.5,22.4921875 17.8515625,21.875 18.75,21.875 C19.6484375,21.875 20,22.4921875 20,22.8125 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCableChannelsLight);
export default __webpack_public_path__ + "static/media/cable-channels-light.4659175e06eb1162d9c834c8ef3d3784.svg";
export { ForwardRef as ReactComponent };